<section class="container">

  <div class="alert alert-info" *ngIf="!controleAgendamentoProcessoHonraBatch || !controleAgendamentoProcessoHonraBatch.length">
    Não foram encontradas execuções de processos batch de honra para a janela indicada.
  </div>
 
    <div class="table-responsive" *ngIf="controleAgendamentoProcessoHonraBatch && controleAgendamentoProcessoHonraBatch.length">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Rotina batch</th>
            <th scope="col">Dt. prev. prim. execução</th>
            <th scope="col">Dt. prev. ult. execução</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of controleAgendamentoProcessoHonraBatch" id="pointer" [routerLink]="['/acompanhamento-batch/', item.id]" >
            <td>{{item.idProcessoBatchHonra}}</td>
            <td>{{item.nomeProcessoBatchHonra}}</td> 
            <td>{{item.dataPrevistaParaPrimeiraExecucao | date: 'dd/MM/yyyy'}}</td>
            <td>{{item.dataPrevistaParaUltimaExecucao | date: 'dd/MM/yyyy'}}</td>
            <td>{{item.sucesso ? 'Sucesso' : (item.sucesso == null ? 'Pendente' : 'Erro') }}</td>
          </tr>
        </tbody>
      </table>
    </div>

</section>
